export const NAME = 'forgotPassword';
